import http from "./Http";

/**
 * PRODUCTION_DEFAULT_ROBOTS
 * This template mirrors the recommended production configuration for search engine optimization.

 */
export const getProductionDefaultRobots = (hostname = "[your-domain.com]") => {
    return [
        "User-agent: *",
        "Allow: /",
        "Disallow: /search",
        "Disallow: /cart",
        "Disallow: /checkout",
        "Disallow: /api/",
        "Disallow: /login",
        "Disallow: /sign-in",
        "Disallow: /sign-up",
        "Disallow: /profile",
        "Disallow: /garage",
        "# Surgical Parameter Blocking (Protects crawl budget from VIN/Fitment traps)",
        "Disallow: /*?vin=",
        "Disallow: /*?fitment=",
        "Disallow: /*?year=",
        "Disallow: /*?model=",
        "Disallow: /*?sort=",
        "Disallow: /*?limit=",
        "",
        "User-agent: Googlebot",
        "Disallow: ",
        "",
        "User-agent: Googlebot-image",
        "Disallow: ",
        "",
        "User-agent: AdsBot-Google",
        "Allow: /",
    ].join("\n");

};

const get = async (dlid) => {
    return http.get(`/robots-txt?dlid=${dlid}`);
};

const update = async (dlid, content) => {
    return http.put(`/robots-txt`, { dlid, content });
};

const RobotsTxtService = {
    get,
    update,
};

export default RobotsTxtService;
